import React, {useState, useEffect} from 'react';
import './App.css';
import {VRScene} from "./ImageViewer";
import {VRMenu} from "./Menu";
// @ts-ignore
import {Scene} from 'aframe-react';

export type Mode = "menu" | "image-1" | "image-2";

function App() {

    const [mode, setMode] = useState("menu")

    const delay = (ms : number) => new Promise(
        resolve => setTimeout(resolve, ms)
    );

    useEffect(() => {
        async function test() {
            console.log('hep1');
            await delay(1000);
            console.log('hep2');
            // @ts-ignore
            document?.querySelector('a-scene')?.enterVR();
        }

        test();
    }, []);

    function ChangeMode(mode : string) {
        // @ts-ignore
      //  document?.querySelector('a-scene')?.enterVR();
        setMode(mode);
    }
    function ChangeToMenu() {
        setMode("menu");
    }

  return (<div style={{position: "absolute", height: "100%", width: "100%"}}>
        <Scene background="color: white">
      { mode === "menu" && <VRMenu OnClick={ChangeMode} /> }
      { mode === "image-1" && <VRScene image={"Community1"} OnBack={ChangeToMenu} />}
      { mode === "image-2" && <VRScene image={"Community2"} OnBack={ChangeToMenu} />}

        </Scene>
      </div>
  );
}

//        document?.querySelector('a-scene')?.enterVR();
export default App;
